import React, { useState, useEffect, useMemo, useRef } from 'react';
import TR from './../../Trans';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import 'video.js/dist/video-js.css';
import LinearProgressWithLabel from '../items/LinearProgressWithLabel';
import Popover from '@mui/material/Popover';
import { Capacitor } from '@capacitor/core';
import Stack from '@mui/material/Stack';
import ContentContainer from './../items/ContentContainer';
import FormControlLabel from '@mui/material/FormControlLabel';
import SvgIcon from '@mui/material/SvgIcon';
import EditPlayList from '../dialogs/EditPlayList';
import Checkbox from '@mui/material/Checkbox';
import RepeatPlayList from '../dialogs/RepeatPlayList';
import muvikaAttrs from './../../attrs';
import Grid from '@mui/material/Grid';
import { ReactComponent as PlayIcon } from './../../assets/play.svg';
import { ReactComponent as PauseIcon } from './../../assets/pause.svg';
import { ReactComponent as NextIcon } from './../../assets/next.svg';
import { ReactComponent as PrevIcon } from './../../assets/prev.svg';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import SavePlayList from '../dialogs/SavePlayList';
import Confirm from './../dialogs/Confirm';
import DeleteDialog from '../dialogs/DeleteDialog';
import ChangePlayList from '../dialogs/ChangePlayList';
import { getOS, getPlatform, isIPhone } from '../../services/os';
import SearchFilters from './../items/SearchFilters';
import MenuItem from '@mui/material/MenuItem';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import MuiToggleButton from "@mui/material/ToggleButton";
import { styled } from "@mui/material/styles";
import StopIcon from '@mui/icons-material/Stop';
import AddBackgroundMusicPlayList from '../dialogs/AddBackgroundMusicPlaylist';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Waiting from './../items/Waiting';
import { ReactComponent as VolumeIcon } from './../../assets/volume.svg';
import NewWindow from 'react-new-window';
import MusicPlayer from './../player/MusicPlayer';
import BackgroundPlayListListItem from '../items/BackgroundPlayListListItem';
import sessionStore from './../../stores/session';
import environmentStore from './../../stores/environment';
import bgPerformanceStore from '../../stores/bgPerformance';
import musicStore from '../../stores/music';
import playerStore from '../../stores/player';
import messageStore from '../../stores/message';
import { render } from '@testing-library/react';
import { decades } from '../../common/decades';
import singersStore from './../../stores/singers';
import settingsStore from '../../stores/settings';
import navigationStore from '../../stores/navigation';

function BgPlaylists() {

  const [scrollTop, setScrollTop] = useState(() => {
    const savedScrollTop = sessionStorage.getItem(muvikaAttrs.service + "-music-playlists-scrolltop");
    const initialValue = JSON.parse(savedScrollTop);
    return initialValue || "";
  });

  const [openPlayLists, setOpenPlayLists] = useState(() => {
    const savedOpenPlayLists = sessionStorage.getItem(muvikaAttrs.service + "-music-playlists-opened");
    const initialValue = JSON.parse(savedOpenPlayLists);
    return initialValue || [];
  });

  const [isAddPlayListOpen, setIsAddPlayListOpen] = useState(false);
  const [chosenPlayList, setChosenPlayList] = useState(null);
  const [isSavePlayQueueOpen, setIsSavePlayQueueOpen] = useState(false);
  const [isSavePlayListOpen, setIsSavePlayListOpen] = useState(false);
  const [isEditPlayListOpen, setIsEditPlayListOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isChangePlayListOpen, setIsChangePlayListOpen] = useState(false);
  const [isRepeatPlayListOpen, setIsRepeatPlayListOpen] = useState(false);
  const [isDialogClosing, setIsDialogClosing] = useState(false);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const isWaiting = bgPerformanceStore((state) => state.isWaiting);
  const playLists = bgPerformanceStore((state) => state.playLists);
  const getPlayLists = bgPerformanceStore((state) => state.getPlayLists);
  const createPlayList = bgPerformanceStore((state) => state.createPlayList);
  const playQueue = bgPerformanceStore((state) => state.playQueue);
  const setPlayList = bgPerformanceStore((state) => state.setPlayList);
  const deletePlayList = bgPerformanceStore((state) => state.deletePlayList);
  const setCurrentPlayList = bgPerformanceStore((state) => state.setCurrentPlayList);
  const savePlayQueue = bgPerformanceStore((state) => state.savePlayQueue);
  const savePlayList = bgPerformanceStore((state) => state.savePlayList);
  const changePlayListName = bgPerformanceStore((state) => state.changePlayListName);
  const setPlayIsOn = bgPerformanceStore((state) => state.setPlayIsOn);
  const clearCurrentPlayList = bgPerformanceStore((state) => state.clearCurrentPlayList);
  const addPlayListToTheEnd = bgPerformanceStore((state) => state.addPlayListToTheEnd);
  const settings = settingsStore((state) => state.settings);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setError = messageStore((state) => state.setError);
  const getSettings = settingsStore((state) => state.getSettings);
  const setSettings = settingsStore((state) => state.setSettings);
  const repeatPlayList = bgPerformanceStore((state) => state.repeatPlayList);
  const setRepeatPlayList = bgPerformanceStore((state) => state.setRepeatPlayList);
  const setRepeatPlayListFromId = bgPerformanceStore((state) => state.setRepeatPlayListFromId);

  const scrollToPos = () => {
    let containerElement = document.getElementById("muvika-music-playlists");
    const savedScrollTop = sessionStorage.getItem(muvikaAttrs.service + "-music-playlists-scrolltop");
    const initialValue = JSON.parse(savedScrollTop);
    let scrollTop = initialValue || null;
    if (containerElement && scrollTop) {
      containerElement.scrollTop = scrollTop;
    }
  };
  
  const playlistsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      console.log("clicked");
      if (playlistsRef.current && !playlistsRef.current.contains(event.target)) {
        console.log("clicked away");
        setIsDialogClosing(true);
        setTimeout(() => scrollToPos(), 100);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!playLists) {
      getPlayLists(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  useEffect(() => {
    if (settings && playLists) {
      setRepeatPlayListFromId(settings.music_playlist_id);
    }
  }, [settings]);

  useEffect(() => {
    if (playLists) {
      let containerElement = document.getElementById("muvika-music-playlists");
      if (containerElement) {
        containerElement.scrollTop = scrollTop;
      }
      if (settings) {
        setRepeatPlayListFromId(settings.music_playlist_id);
      }
    }
  }, [playLists]);

  const handleOpenRepeatPlayList = () => {
    setIsRepeatPlayListOpen(true);
  };

  const handleOpenSavePlayList = () => {
    setIsSavePlayListOpen(true);
  };

  const handleOpenChangePlayList = () => {
    setIsChangePlayListOpen(true);
  };

  const handleCloseSavePlayList = () => {
    setIsSavePlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenEditPlayList = () => {
    setIsEditPlayListOpen(true);
  };

  const handleCloseEditPlayList = () => {
    setIsEditPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleCloseChangePlayList = () => {
    setIsChangePlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleCloseRepeatPlayList = () => {
    setIsRepeatPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleOpenAddPlayList = () => {
    setIsAddPlayListOpen(true);
  };

  const handleCloseAddPlayList = () => {
    setIsAddPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handlePlayListCreation = (playListName) => {
    if (playListName.length > 0) {
      createPlayList(sessionToken, playListName);
      setIsAddPlayListOpen(false);
      setTimeout(() => scrollToPos(), 100);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const handleConfirmation = () => {
    savePlayList(sessionToken, chosenPlayList.id, chosenPlayList.name);
    setIsSavePlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleDeletion = () => {
    if (chosenPlayList) {
      if (repeatPlayList) {
        if (chosenPlayList.id === repeatPlayList.id) {
          setRepeatPlayList(null);
          saveRepeatPlayList(0);
        }
      }
      deletePlayList(sessionToken, chosenPlayList.id);
    }
    setIsDeleteDialogOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handlePlayQueueSave = (playListName) => {
    if (playListName.length > 0) {
      savePlayQueue(sessionToken, playListName);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
    setIsSavePlayQueueOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handlePlayListEdit = (playListName) => {
    if (chosenPlayList && playListName.length > 0) {
      changePlayListName(sessionToken, playListName, chosenPlayList);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
    setIsEditPlayListOpen(false);
    setTimeout(() => scrollToPos(), 100);
  };

  const handleReplacePlayList = () => {
    setCurrentPlayList(sessionToken, chosenPlayList);
    handleCloseChangePlayList();
  };

  const handleAddPlayListToEnd = () => {
    setIsAutoPlayOn(false);
    if (playQueue) {
      if (playQueue.items.length == 0) {
        setIsStopped(true);
        setIsAutoPlayOn(true);
      }
    }
    addPlayListToTheEnd(sessionToken, chosenPlayList);
    handleCloseChangePlayList();
  };

  const saveRepeatPlayList = (playListId) => {
    let newSettings = { ...settings };
    newSettings.music_playlist_id = playListId;
    setSettings(sessionToken, newSettings, false);
  };

  const handleRepeatReplacePlayList = () => {
    setCurrentPlayList(sessionToken, chosenPlayList);
    setRepeatPlayList(chosenPlayList);
    saveRepeatPlayList(chosenPlayList.id);
    handleCloseRepeatPlayList();
  };

  const handleRepeatAddPlayListToEnd = () => {
    setIsAutoPlayOn(false);
    if (playQueue) {
      if (playQueue.items.length == 0) {
        setIsStopped(true);
        setIsAutoPlayOn(true);
      }
    }
    addPlayListToTheEnd(sessionToken, chosenPlayList);
    setRepeatPlayList(chosenPlayList);
    saveRepeatPlayList(chosenPlayList.id);
    handleCloseRepeatPlayList();
  };

  const playListList = useMemo(() => {
    if (playLists) {
      const savedOpenPlayLists = sessionStorage.getItem(muvikaAttrs.service + "-music-playlists-opened");
      const initialValue = JSON.parse(savedOpenPlayLists);
      let openPlayLists = initialValue || [];
      return playLists.map((playList, index) =>
        <BackgroundPlayListListItem
          key={playList.id}
          id={playList.id}
          name={playList.name}
          created={playList.created}
          open={openPlayLists.includes(playList.id)}
          onEditPerformanceClose={() => {
            setIsDialogClosing(true);
            setTimeout(() => scrollToPos(), 100);
          }}
          performances={playList.items}
          playList={playList}
          isRepeatPlayList={repeatPlayList ? playList.id === repeatPlayList.id : false}
          onSetCurrentPlayList={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenChangePlayList();
          }}
          onOpenEditDialog={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenEditPlayList();
          }}
          onOpenDeleteDialog={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenDeleteDialog();
          }}
          onOpenSavePlayListDialog={(e) => {

            e.stopPropagation();
            setChosenPlayList(playList);
            handleOpenSavePlayList();
          }}
          onRepeat={(e) => {

            e.stopPropagation();
            if (repeatPlayList) {
              if (repeatPlayList.id === playList.id) {
                setRepeatPlayList(null);
                saveRepeatPlayList(0);
                return;
              }
            }
            setChosenPlayList(playList);
            handleOpenRepeatPlayList();
          }
          }
        />
      );
    }
  }, [playLists, repeatPlayList]);

  const waitingRender = () => {
    if (!isWaiting) {
      return playListList;
    } else {
      return <Waiting />;
    }
  };

  const renderNewPlayListButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <IconButton className="muvika-button-right" color="white" component="label" onClick={(e) => {
          e.stopPropagation();
          handleOpenAddPlayList();
        }}>
          <AddCircleIcon />
        </IconButton>;
      }
    }
  };

  const saveScrollTop = (scrollTop) => {
    if (!isDialogClosing) {
      sessionStorage.setItem(muvikaAttrs.service + "-music-playlists-scrolltop", scrollTop);
    }
    setIsDialogClosing(false);
  };

  const renderContainer = () => {
    console.log("rendering bg contentcontainer");
    setTimeout(() => scrollToPos(), 100);
    return <ContentContainer id="muvika-music-playlists" onScroll={(scrollTop) => saveScrollTop(scrollTop)} onScrollDown={() => {
    }} isFinished={true}>
      {waitingRender()}
    </ContentContainer>;
  };

  return (
    <div ref={playlistsRef}>
      <AddBackgroundMusicPlayList
        open={isAddPlayListOpen}
        onClose={handleCloseAddPlayList}
        onPlayListCreation={handlePlayListCreation}
      />
      <EditPlayList
        open={isEditPlayListOpen}
        playListName={chosenPlayList ? chosenPlayList.name : ""}
        onClose={handleCloseEditPlayList}
        onPlayListEdit={handlePlayListEdit}
      />
      <DeleteDialog
        openToLeft={true}
        open={isDeleteDialogOpen}
        onClose={handleCloseDeleteDialog}
        onDeletion={handleDeletion}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_delete}
      />
      <Confirm
        openToLeft={true}
        open={isSavePlayListOpen}
        onClose={handleCloseSavePlayList}
        onConfirmation={handleConfirmation}
      />
      <ChangePlayList
        openToLeft={true}
        isEmpty={playQueue ? playQueue.items.length == 0 : false}
        open={isChangePlayListOpen}
        onClose={handleCloseChangePlayList}
        onReplace={handleReplacePlayList}
        onAddToEnd={handleAddPlayListToEnd}
      />
      <RepeatPlayList
        isEmpty={playQueue ? playQueue.items.length == 0 : false}
        open={isRepeatPlayListOpen}
        onClose={handleCloseRepeatPlayList}
        onReplace={handleRepeatReplacePlayList}
        onAddToEnd={handleRepeatAddPlayListToEnd}
      />
      <Grid container spacing={0}>
        <Grid item xs={11}>
          <h3>{TR.cm_bg_playlists}</h3>
        </Grid>
        <Grid item xs={1}>
          {renderNewPlayListButton()}
        </Grid>
      </Grid>
      {renderContainer()}
    </div>
  );
}

export default BgPlaylists;